// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RT2 Link / Unlink Test Suites modal */

.rt-link-suites-overlay {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));
  backdrop-filter: blur(2px);
}

[data-theme="dark"] .rt-link-suites-overlay {
  background: rgba(2, 8, 20, 0.72);
}

.rt-link-suites-panel {
  width: min(520px, 94vw);
  max-height: min(720px, 88vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--modal-background, var(--surface, #fff));
  color: var(--text-primary);
  border: 1px solid var(--border-strong, var(--border));
  border-radius: 14px;
  box-shadow: var(--modal-shadow, var(--shadow-lg));
}

.rt-link-suites-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 1.1rem 1.25rem 1rem;
  border-bottom: 1px solid var(--border);
  background: var(--surface);
}

.rt-link-suites-header h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.rt-link-suites-header p {
  margin: 0.3rem 0 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.35;
}

.rt-link-suites-close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-secondary);
  font-size: 1.35rem;
  line-height: 1;
  cursor: pointer;
}

.rt-link-suites-close:hover {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.rt-link-suites-form {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
}

.rt-link-suites-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  flex: 1 1;
  padding: 1rem 1.25rem;
}

.rt-link-suites-banner {
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  border: 1px solid color-mix(in srgb, var(--warning, #f59e0b) 35%, var(--border));
  background: var(--warning-muted, rgba(245, 158, 11, 0.12));
  color: var(--text-primary);
  font-size: 0.82rem;
  line-height: 1.4;
}

.rt-link-suites-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.rt-link-suites-search {
  flex: 1 1 160px;
  min-width: 140px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--input-border, var(--border));
  border-radius: 8px;
  background: var(--input-background, var(--surface));
  color: var(--text-primary);
  font-size: 0.875rem;
}

.rt-link-suites-search::placeholder {
  color: var(--input-placeholder, var(--text-muted));
}

.rt-link-suites-search:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--shadow-focus);
}

.rt-link-suites-count {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
}

.rt-link-suites-list {
  list-style: none;
  margin: 0;
  padding: 0;
  min-height: 200px;
  max-height: 380px;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--bg-secondary, var(--surface));
}

.rt-link-suites-list li + li {
  border-top: 1px solid var(--border-subtle, var(--border));
}

.rt-link-suites-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.7rem 0.9rem;
  cursor: pointer;
  transition: background 0.12s ease;
  margin: 0;
}

.rt-link-suites-item:hover {
  background: var(--surface-hover);
}

.rt-link-suites-item.is-selected {
  background: var(--primary-muted);
}

.rt-link-suites-item input[type='checkbox'] {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: var(--primary);
  cursor: pointer;
}

.rt-link-suites-item__name {
  flex: 1 1;
  min-width: 0;
  font-size: 0.9rem;
  font-weight: 520;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rt-link-suites-item__id {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-muted);
  font-variant-numeric: tabular-nums;
}

.rt-link-suites-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  padding: 1.5rem;
  border: 1px dashed var(--border);
  border-radius: 10px;
  color: var(--text-secondary);
  font-size: 0.9rem;
  text-align: center;
}

.rt-link-suites-state--error {
  color: var(--danger);
  border-color: color-mix(in srgb, var(--danger) 40%, var(--border));
  background: var(--danger-muted);
}

.rt-link-suites-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0.9rem 1.25rem 1.1rem;
  border-top: 1px solid var(--border);
  background: var(--surface);
}

[data-theme="light"] .rt-link-suites-list {
  background: #fff;
}

[data-theme="dark"] .rt-link-suites-header,
[data-theme="dark"] .rt-link-suites-footer {
  background: var(--surface-raised, var(--surface));
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-link-suites.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yDAAyD;EACzD,0BAA0B;EAC1B,qDAAqD;EACrD,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gFAAgF;EAChF,0DAA0D;EAC1D,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,mDAAmD;EACnD,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kEAAkE;EAClE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iDAAiD;AACnD","sourcesContent":["/* RT2 Link / Unlink Test Suites modal */\n\n.rt-link-suites-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: var(--modal-backdrop, rgba(15, 23, 42, 0.55));\n  backdrop-filter: blur(2px);\n}\n\n[data-theme=\"dark\"] .rt-link-suites-overlay {\n  background: rgba(2, 8, 20, 0.72);\n}\n\n.rt-link-suites-panel {\n  width: min(520px, 94vw);\n  max-height: min(720px, 88vh);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--modal-background, var(--surface, #fff));\n  color: var(--text-primary);\n  border: 1px solid var(--border-strong, var(--border));\n  border-radius: 14px;\n  box-shadow: var(--modal-shadow, var(--shadow-lg));\n}\n\n.rt-link-suites-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 1.1rem 1.25rem 1rem;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface);\n}\n\n.rt-link-suites-header h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.rt-link-suites-header p {\n  margin: 0.3rem 0 0;\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  line-height: 1.35;\n}\n\n.rt-link-suites-close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--text-secondary);\n  font-size: 1.35rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.rt-link-suites-close:hover {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n.rt-link-suites-form {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n}\n\n.rt-link-suites-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  flex: 1;\n  padding: 1rem 1.25rem;\n}\n\n.rt-link-suites-banner {\n  padding: 0.65rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid color-mix(in srgb, var(--warning, #f59e0b) 35%, var(--border));\n  background: var(--warning-muted, rgba(245, 158, 11, 0.12));\n  color: var(--text-primary);\n  font-size: 0.82rem;\n  line-height: 1.4;\n}\n\n.rt-link-suites-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.rt-link-suites-search {\n  flex: 1 1 160px;\n  min-width: 140px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--input-border, var(--border));\n  border-radius: 8px;\n  background: var(--input-background, var(--surface));\n  color: var(--text-primary);\n  font-size: 0.875rem;\n}\n\n.rt-link-suites-search::placeholder {\n  color: var(--input-placeholder, var(--text-muted));\n}\n\n.rt-link-suites-search:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.rt-link-suites-count {\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.rt-link-suites-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  min-height: 200px;\n  max-height: 380px;\n  overflow-y: auto;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--bg-secondary, var(--surface));\n}\n\n.rt-link-suites-list li + li {\n  border-top: 1px solid var(--border-subtle, var(--border));\n}\n\n.rt-link-suites-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0.7rem 0.9rem;\n  cursor: pointer;\n  transition: background 0.12s ease;\n  margin: 0;\n}\n\n.rt-link-suites-item:hover {\n  background: var(--surface-hover);\n}\n\n.rt-link-suites-item.is-selected {\n  background: var(--primary-muted);\n}\n\n.rt-link-suites-item input[type='checkbox'] {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  accent-color: var(--primary);\n  cursor: pointer;\n}\n\n.rt-link-suites-item__name {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.9rem;\n  font-weight: 520;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rt-link-suites-item__id {\n  flex-shrink: 0;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: var(--text-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-link-suites-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n  padding: 1.5rem;\n  border: 1px dashed var(--border);\n  border-radius: 10px;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.rt-link-suites-state--error {\n  color: var(--danger);\n  border-color: color-mix(in srgb, var(--danger) 40%, var(--border));\n  background: var(--danger-muted);\n}\n\n.rt-link-suites-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 0.9rem 1.25rem 1.1rem;\n  border-top: 1px solid var(--border);\n  background: var(--surface);\n}\n\n[data-theme=\"light\"] .rt-link-suites-list {\n  background: #fff;\n}\n\n[data-theme=\"dark\"] .rt-link-suites-header,\n[data-theme=\"dark\"] .rt-link-suites-footer {\n  background: var(--surface-raised, var(--surface));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
